import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Section } from '../components/Section';
const subprocessors = [{
  provider: 'Anthropic',
  dataProcessed: 'De-identified employee and customer feedback data submitted by clients',
  classification: 'Platform subprocessor',
  purpose: "AI language model processing used in Huwey's feedback analysis pipeline",
  country: 'United States'
}, {
  provider: 'Microsoft Azure',
  dataProcessed: 'Platform data and client feedback data processed via cloud infrastructure',
  classification: 'Platform subprocessor',
  purpose: 'Cloud computing infrastructure supporting platform operations',
  country: 'United States'
}, {
  provider: 'Clark',
  dataProcessed: 'User authentication data, including email address and login credentials',
  classification: 'Platform subprocessor',
  purpose: 'User identity and authentication management for the Huwey platform',
  country: 'United States'
}, {
  provider: 'Google (Gemini)',
  dataProcessed: 'De-identified employee and customer feedback data submitted by clients',
  classification: 'Platform subprocessor',
  purpose: "AI language model processing used in Huwey's feedback analysis pipeline",
  country: 'United States'
}, {
  provider: 'Google Workspace',
  dataProcessed: 'Email correspondence and contact details for client representatives; internal documents and files',
  classification: 'Business operations',
  purpose: 'Email, document storage, and collaboration tools used in business operations and client communications',
  country: 'United States'
}, {
  provider: 'Microsoft 365 & Teams',
  dataProcessed: 'Business correspondence and contact information for client representatives; content shared during meetings and demos',
  classification: 'Business operations',
  purpose: 'Productivity tools, internal communications, and video meetings including client demos',
  country: 'United States'
}, {
  provider: 'OpenAI',
  dataProcessed: 'De-identified employee and customer feedback data submitted by clients',
  classification: 'Platform subprocessor',
  purpose: "AI language model processing used in Huwey's feedback analysis pipeline",
  country: 'United States'
}, {
  provider: 'Perplexity',
  dataProcessed: 'Client-specific working documents and contextual information submitted by HiddenMatter staff in connection with services engagements',
  classification: 'Platform subprocessor',
  purpose: 'AI-assisted research used by HiddenMatter staff when developing client deliverables; client documents may be submitted as context for queries',
  country: 'United States'
}, {
  provider: 'QuickBooks (Intuit)',
  dataProcessed: 'Financial records including invoices and payment information for clients and vendors',
  classification: 'Business operations',
  purpose: "Accounting and invoicing platform used to manage HiddenMatter's financial operations",
  country: 'United States'
}, {
  provider: 'Salesforce',
  dataProcessed: 'Contact information for client and prospect representatives, including name, email, and company',
  classification: 'Business operations',
  purpose: 'Customer relationship management platform used to manage business relationships',
  country: 'United States'
}, {
  provider: 'Supabase',
  dataProcessed: 'Platform user data and processed feedback data and analytical outputs for the Huwey platform',
  classification: 'Platform subprocessor',
  purpose: 'Database and data storage infrastructure for the Huwey platform',
  country: 'United States'
}, {
  provider: 'Vercel',
  dataProcessed: 'Platform user data and any data transmitted through the Huwey application',
  classification: 'Platform subprocessor',
  purpose: 'Application hosting and delivery infrastructure for the Huwey platform',
  country: 'United States'
}, {
  provider: 'Zoom',
  dataProcessed: 'Business correspondence and contact information for client representatives; content shared during meetings and demos',
  classification: 'Business operations',
  purpose: 'Video conferencing used for client meetings and product demonstrations',
  country: 'United States'
}];
export function Subprocessors() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-684" data-mp="59dfhgygusc5">
      <Navbar data-id="element-685" data-mp="aa17a4uird7f" />
      <main className="flex-grow" data-id="element-686" data-mp="a9hypeqre162">
        <Section className="pt-32 md:pt-48" data-id="element-687" data-mp="aaj8lfw1ghm7">
          <div className="max-w-4xl mx-auto" data-id="element-688" data-mp="eb398tftm3d3">
            <h1 className="font-poppins font-normal text-3xl md:text-4xl text-black mb-4" data-id="element-689" data-mp="eatg4wzhbg36">
              Subprocessors & Service Providers
            </h1>
            <p className="font-inter text-base text-black mb-8" data-id="element-690" data-mp="2g26j3ghvzdwl">
              Effective Date: 7 April 2026
            </p>

            <div className="space-y-8 font-inter text-base leading-relaxed text-black" data-id="element-691" data-mp="28jyw2nvujo4k">
              {/* Overview */}
              <div data-id="element-692" data-mp="23r5qxywgudry">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-693" data-mp="23qnmiezngt8y">
                  Overview
                </h2>
                <div className="space-y-4" data-id="element-694" data-mp="1uslgfl127aet">
                  <p data-id="element-695" data-mp="1uppgjr5nibnq">
                    To deliver the Huwey platform and operate our business,
                    HiddenMatter works with a set of third-party service
                    providers. Some of these providers process personal data on
                    our behalf in connection with the platform. Others support
                    our internal business operations and may have incidental
                    access to personal data, such as contact information for
                    client representatives.
                  </p>
                  <p data-id="element-696" data-mp="122v8xutxn6ro">
                    We hold all providers to contractual data protection
                    obligations consistent with those we assume under our
                    Customer Data Processing Addendum. Before engaging any new
                    provider that will touch client data, we conduct a vendor
                    security assessment.
                  </p>
                  <p data-id="element-697" data-mp="yko0qnywlu78">
                    If you are a client with questions about a specific provider
                    or would like to raise an objection, please contact us at{' '}
                    <a href="mailto:chat@hiddenmatter.ai" className="text-black hover:text-lime transition-colors underline" data-id="element-698" data-mp="pk92ko0uckmb">
                      chat@hiddenmatter.ai
                    </a>
                    .
                  </p>
                  <p data-id="element-699" data-mp="1v6nnnxld5vi">
                    Clients with an active Data Processing Addendum will be
                    notified of material changes to this list before a new
                    subprocessor begins processing their data.
                  </p>
                </div>
              </div>

              {/* Provider List */}
              <div className="pt-4" data-id="element-700" data-mp="3efke6a7fysxr">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-701" data-mp="3egn3idp48nbk">
                  Provider List
                </h2>
                <div className="overflow-x-auto -mx-4 px-4" data-id="element-702" data-mp="3ocgpsosmzv6j">
                  <table className="w-full border-collapse text-sm md:text-base min-w-[700px]" data-id="element-703" data-mp="3of2veivyw0m4">
                    <thead data-id="element-704" data-mp="64r1262i9d7j">
                      <tr className="bg-[#003651] text-white" data-id="element-705" data-mp="18ird872uc7r">
                        <th className="text-left font-semibold px-4 py-3 border border-[#003651]" data-id="element-706" data-mp="166a6x9585vr">
                          Provider
                        </th>
                        <th className="text-left font-semibold px-4 py-3 border border-[#003651]" data-id="element-707" data-mp="az4ysf4n3wfd">
                          Data Processed
                        </th>
                        <th className="text-left font-semibold px-4 py-3 border border-[#003651]" data-id="element-708" data-mp="jz0duv1bgbko">
                          Classification
                        </th>
                        <th className="text-left font-semibold px-4 py-3 border border-[#003651]" data-id="element-709" data-mp="1rdabjpxd2uwj">
                          Purpose
                        </th>
                        <th className="text-left font-semibold px-4 py-3 border border-[#003651]" data-id="element-710" data-mp="20cxdccu062q4">
                          Country
                        </th>
                      </tr>
                    </thead>
                    <tbody data-id="element-711" data-mp="18mat77kdgjc8">
                      {subprocessors.map((row, index) => <tr key={row.provider} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-712" data-mp="1cmkxmfsin1oz" data-mpi={index}>
                          <td className="px-4 py-3 border border-gray-200 font-semibold align-top" data-id="element-713" data-mp="owgvkcuz7a03">
                            {row.provider}
                          </td>
                          <td className="px-4 py-3 border border-gray-200 align-top" data-id="element-714" data-mp="tth36s7h4ktb">
                            {row.dataProcessed}
                          </td>
                          <td className="px-4 py-3 border border-gray-200 align-top" data-id="element-715" data-mp="hdzki27gbn50">
                            {row.classification}
                          </td>
                          <td className="px-4 py-3 border border-gray-200 align-top" data-id="element-716" data-mp="8cjjgl2j0xdg">
                            {row.purpose}
                          </td>
                          <td className="px-4 py-3 border border-gray-200 align-top" data-id="element-717" data-mp="3ehph53kbdn7">
                            {row.country}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Updates to This Page */}
              <div className="pt-4" data-id="element-718" data-mp="3gsl2bxvctvrg">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-719" data-mp="3grjqvsaff797">
                  Updates to This Page
                </h2>
                <div className="space-y-4" data-id="element-720" data-mp="3jba0hris0vy5">
                  <p data-id="element-721" data-mp="3j9yurm5rte4e">
                    HiddenMatter evaluates and adjusts its technology stack on
                    an ongoing basis. We update this page to reflect additions
                    and removals as they occur. Clients with an active Data
                    Processing Addendum will receive advance written notice of
                    any new subprocessor that will process their data, in
                    accordance with the terms of their agreement.
                  </p>
                  <p data-id="element-722" data-mp="2vew2f47rcsj6">
                    Under the terms of our Data Processing Addendum, clients may
                    object in writing to the use of a new subprocessor. If no
                    objection is raised within that period, the new subprocessor
                    is deemed accepted.
                  </p>
                </div>
              </div>

              {/* Questions */}
              <div className="pt-4" data-id="element-723" data-mp="kkro0kwh5yy4">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-724" data-mp="knvx9wosrkvn">
                  Questions
                </h2>
                <p data-id="element-725" data-mp="x56rogeahsyt">
                  Questions about this page or a specific provider? Contact us
                  at{' '}
                  <a href="mailto:chat@hiddenmatter.ai" className="text-black hover:text-lime transition-colors underline" data-id="element-726" data-mp="j5yqjhykgarz">
                    chat@hiddenmatter.ai
                  </a>
                </p>
              </div>
            </div>
          </div>
        </Section>
      </main>
      <Footer data-id="element-727" data-mp="123i0cnsulxfg" />
    </div>;
}